import {extendCrudApiByHousehold} from '@/utils/api.js';

const recipesImportsApi = extendCrudApiByHousehold({
  entityNameSingular: 'RecipesImport',
  entityNamePlural: 'RecipesImports',
  entityPath: 'recipes/imports',
  extraTags: ['Recipes'],
  extraEndpoints: (builder) => ({
    stopRecipesImport: builder.mutation({
      query: ({ householdId, id }) => ({
        url: `/h/${householdId}/recipes/imports/${id}/.stop`,
        method: 'POST',
      }),
    }),
    createRecipesImport: builder.mutation({
      query: ({ householdId, data }) => ({
        url: `/h/${householdId}/recipes/imports/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'RecipesImports', id: 'LIST', householdId: arg.householdId },
        { type: 'Recipes', id: 'LIST', householdId: arg.householdId },
      ],
    }),
  }),
});

export const {
  useGetRecipesImportsQuery,
  useGetRecipesImportQuery,  
  useCreateRecipesImportMutation,
  useStopRecipesImportMutation,
} = recipesImportsApi;
